var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"radio"},[_c('input',{attrs:{"type":"radio"},domProps:{"checked":_vm.shouldBeChecked,"value":_vm.value},on:{"change":_vm.updateInput}}),_vm._m(0),_c('span',{staticClass:"radio__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio__dummy"},[_c('div',{staticClass:"radio__dummy_circle"})])
}]

export { render, staticRenderFns }